module.exports = __webpack_public_path__ + "img/cang hai phong-chi nhanh tan vu.b8442a88.jpg";